import { ref } from 'vue'
import { BASE_URL } from "@/composables/url_config"
import { log } from "@/composables/useLog"
import axios from "axios"

const error = ref(null)

// Get all settings parameters
export const getSettingsParameters = async (token) => {
  log("welcome in getSettingsParameters")

  if (!token || token === "") {
    return { error: true, message: "No token provided", settings: [] }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/get_settings_parameters_api'

    const result = await axios.get(url, { headers })
    log("result.data from getSettingsParameters")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in getSettingsParameters")
    log(err)
    error.value = err.message
    return { error: true, message: "Error fetching settings", settings: [] }
  }
}

// Save (create or update) a setting parameter
export const saveSettingParameter = async (token, settingData) => {
  log("welcome in saveSettingParameter")
  log(settingData)

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/save_setting_parameter_api'

    const result = await axios.post(url, settingData, { headers })
    log("result.data from saveSettingParameter")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in saveSettingParameter")
    log(err)
    error.value = err.message
    return { error: true, message: "Error saving setting" }
  }
}

// Delete a setting parameter
export const deleteSettingParameter = async (token, settingId) => {
  log("welcome in deleteSettingParameter")

  if (!token || token === "") {
    return { error: true, message: "No token provided" }
  }

  try {
    const headers = {
      "Authorization": `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept": "application/json"
    }

    let url = BASE_URL + '/home/delete_setting_parameter_api'

    const result = await axios.post(url, { id: settingId }, { headers })
    log("result.data from deleteSettingParameter")
    log(result.data)

    return result.data
  } catch (err) {
    log("Error in deleteSettingParameter")
    log(err)
    error.value = err.message
    return { error: true, message: "Error deleting setting" }
  }
}

const useSettingsParametersAPI = () => {
  return { error, getSettingsParameters, saveSettingParameter, deleteSettingParameter }
}

export default useSettingsParametersAPI
